import { edition } from '../edition/index.js';

/** Games that can be played with the Big Cards deck (8 to Ace). */
export type BigCardsGame = 'hearts' | 'rummy' | 'pirate';

const key = (game: BigCardsGame) => `s4k:big-cards:${game}`;

/** The player's stored choice for a game, or null when they never made one (or storage is unavailable). */
export function storedBigCards(game: BigCardsGame): boolean | null {
  try {
    const raw = localStorage.getItem(key(game));
    return raw === '1' ? true : raw === '0' ? false : null;
  } catch {
    return null;
  }
}

/** Remember the player's choice on this device. */
export function rememberBigCards(game: BigCardsGame, on: boolean): void {
  try {
    localStorage.setItem(key(game), on ? '1' : '0');
  } catch {
    /* private window or blocked storage: the choice just lasts for this visit */
  }
}

/** Which deck a game starts with: `?bigcards=` (a test or audit pin), else what the player chose, else the edition's default. */
export function resolveBigCards(game: BigCardsGame, pin: boolean | null | undefined): boolean {
  return pin ?? storedBigCards(game) ?? edition.bigCardsDefault ?? false;
}
